import { useTracker } from '@coursera/event-pulse/react';

import { AUTHENTICATION_MODAL_MODES } from 'bundles/authentication/constants';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import { useAuthModalTrackerContext } from 'bundles/authentication/shared/components/authentication-modal/contexts/AuthenticationTracking';

const AuthenticationContentTracker = () => {
  const track = useTracker();
  const modalName = useAuthModalTrackerContext()?.modalName;

  if (modalName === AUTHENTICATION_MODAL_MODES.SIGNUP || modalName === AUTHENTICATION_MODAL_MODES.LOGIN) {
    track('view_modal', { modal: { name: modalName } });
  }

  return null;
};

export default AuthenticationContentTracker;
